import Hero from "@components/Hero/Hero"
import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components";

export const PlatformHeroHERO = styled(Hero)`
  .buttons-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: var(--spacing--S) var(--spacing--XS);

    .Button {
      flex: 0 0 100%;
      text-align: center;

      ${MEDIA_QUERIES.S} {
        flex: 0 0 auto;
      }

      &.watch-video {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0 6px;
      }
    }

    .PlayButton {
      position: static;
      display: inline-block;
      width: 20px !important;
      height: 20px !important;
      transform: none;
      display: flex;
      align-items: center;
      justify-content: center;
      background: transparent;
      box-shadow: inset 0 0 0 1px var(--color--basics-white);
    }
  }
`
